import { post } from 'core/network/RestApi';
import { ClientLevel } from 'core/types';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useParams } from 'react-router';
import { IDbFileExportConfig } from '../entities/fileExportConfig';
import { FileExportConfigPage } from './FileExportConfigPage';

export const CreateFileExportConfigPage = () => {
  const [s3SubFolder, setS3SubFolder] = useState('');
  const [saveEnabled, setSaveEnabled] = useState(false);
  const [timestampRemoval, setTimestampRemoval] = useState(false);
  const [timestampFormat, setTimestampFormat] = useState(false);
  const [compressFile, setCompressFile] = useState(false);

  const { clientId } = useParams<{ clientId: string }>();

  const location = useLocation<{
    clientLevel: ClientLevel;
    clientName: string;
  }>();

  const { clientLevel, clientName } = location.state || {};

  const postNewFileExportConfig = useMutation((fileExportConfig: IDbFileExportConfig) =>
    post<{ clientId: string }, IDbFileExportConfig>(`/${clientLevel}s/${clientId}/file_export`, fileExportConfig),
  );

  useEffect(() => {
    setSaveEnabled(!!s3SubFolder && !postNewFileExportConfig.isLoading);
  }, [s3SubFolder, postNewFileExportConfig.isLoading]);

  const discardChanges = () => {
    setS3SubFolder('');
    setTimestampFormat(false);
    setTimestampRemoval(false);
    setCompressFile(false);
  };

  return (
    <FileExportConfigPage
      s3SubFolder={s3SubFolder}
      timestampRemoval={timestampRemoval}
      timestampFormat={timestampFormat}
      compressFile={compressFile}
      saveEnabled={saveEnabled}
      clientId={clientId}
      onDiscardChanges={discardChanges}
      clientName={clientName}
      setTimestampRemoval={setTimestampRemoval}
      setTimestampFormat={setTimestampFormat}
      setCompressFile={setCompressFile}
      setS3SubFolder={setS3SubFolder}
      clientLevel={clientLevel}
      mutate={postNewFileExportConfig.mutate}
    />
  );
};
